export const VirtualizedContentBoxHeight = 'calc(100vh - 145px) !important';
export const VirtualizedListTableBoxHeight = 'calc(100vh - 210px) !important';

export const ListItemWidth = 'calc(100% - 0px)';
export const ListItemHeaderWidth = 'calc(100% - 17px)';

export const NoMarginPageWrapper = {
    marginTop: -24,
}